<form class="row g-2" novalidate [formGroup]="confirmationVehicleForm" (ngSubmit)="next()">
    <div class="col-sm-8">
        <label class="col-12 form-label m-0" for="startOperationsDate">Fecha Incicio de Operaciones</label>
        <div class="col-12 input-group">
            <input class="datepicker-here form-control digits" placeholder="yyyy-mm-dd" id="startOperationsDate"
                   name="startOperationsDate" formControlName="startOperationsDate" ngbDatepicker #d="ngbDatepicker"
                   (click)="d.toggle()">
        </div>
    </div>
    <div class="col-sm-6">
        <label class="col-12 form-label m-0" for="initialKm">KM Inicial<span class="txt-danger"> *</span></label>
        <div class="col-12 custom-input">
            <input class="form-control" id="initialKm" type="text" formControlName="initialKm">
        </div>
    </div>
    <div class="product-buttons mb-4 col-12">
        <button class="btn" type="submit">
            <div class="d-flex align-items-center gap-sm-2 gap-1">Confirmar
                <app-common-svg-icons [icons]="'front-arrow'"></app-common-svg-icons>
            </div>
        </button>
    </div>
</form>
